import defaults from './auditDefaults'
import types from './auditTypes'

const mutations = {
  [types.SET_AUDIT_LOGS](state, payload) {
    state.logs = payload.logs
  },

  [types.CLEAR_AUDIT_LOGS](state) {
    state.logs = []
  },

  [types.SET_FILTERS](state, payload) {
    state.filters = payload.filters
  },

  [types.CLEAR_FILTERS](state) {
    state.filters = defaults.filters
  },

  [types.SET_CURRENT_PAGE](state, payload) {
    state.currentPage = payload.page
  },

  [types.CLEAR_CURRENT_PAGE](state) {
    state.currentPage = defaults.page
  },

  [types.SET_SORT](state, payload) {
    state.sort = {
      by: payload.by,
      order: payload.order,
    }
  },

  [types.CLEAR_SORT](state) {
    state.sort = defaults.sort
  },

  [types.SET_TOTAL_PAGES](state, payload) {
    state.totalPages = payload.totalPages
  },

  [types.SET_TOTAL_ITEMS](state, payload) {
    state.totalItems = payload.totalItems
  },

  [types.SET_LIMIT](state, payload) {
    state.limit = payload.limit
  },
}

export default mutations
